import { requestAPI } from 'utils/api'

export const deleteAccounts = (params: { type: any, value: any }) => {
  return requestAPI({
    method: 'DELETE', url: '/qa/deleteaccounts', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteAccountsBoth = (params: { account_ulid: any }) => {
  return requestAPI({
    method: 'DELETE', url: '/qa/deleteaccounts/both', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}


export const sendTestPush = (params: { account_ulid: any }) => {
  return requestAPI({
    method: 'POST', url: '/fcm/push/testdecvip', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const sendCustomPush = (params: {
  account_ulid: any,
  title: any,
  body: any,
  use_localized_key?: any,
  title_loc_key?: any,
  body_loc_key?: any
}) => {
  return requestAPI({
    method: 'POST', url: '/fcm/push/custom', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}
